module.exports = __webpack_public_path__ + "static/media/weight.372ef0ef.svg";